import {
  UPDATE_CHAT_CONVERSATION_REQUEST,
  updateChatConversationSuccess,
  updateChatConversationFailure
}                      from 'Redux/Action';
import { ofType }      from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap }    from 'rxjs/operators';

export function updateChatConversationEpic(action$, store$, { ChatRepository }) {
  return action$.pipe(
    ofType(UPDATE_CHAT_CONVERSATION_REQUEST),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        ChatRepository.update(id, action.payload.formData)
          .then((conversation) => updateChatConversationSuccess(conversation))
          .catch(error => updateChatConversationFailure(error)),
      );
    }),
  );
}
